import styled from 'styled-components';
import { SeriesStatusMessageWrapper, MessageWrapper, BroadcastsWrapper } from 'bdata-react-mini-scoreboard-game-infinity/lib/components//SeriesStatusMessageLayer/SeriesStatusMessageLayer.style';

export const HeaderWrapper = styled.div`
    display: block;

    ${SeriesStatusMessageWrapper} {
        display: flex !important;  
    }

    ${MessageWrapper} {
        span {
            display: inline-block;
        }
        font-size: 11px;
        font-weight: bold;
    }

    ${BroadcastsWrapper} {
        margin-right: 15px;
    }
`;
